import { createContext } from "react";
import { UserAndMetadata, nullUser } from "./authUserProvider";

export default createContext<UserAndMetadata>(nullUser);
